// @ts-nocheck

import React from 'react';

import { getChecks } from '../../selectors/grid';
import type { GridsCheckType, GridMatch } from '../../types';
import GridLine from '../grid/GridsGridLine';

type Props = {
  className?: string;
  matches: Array<GridMatch>;
  selection: string;
  resultSelection?: string;
  onCheckBox?: (matchIndex: number, checkType: GridsCheckType) => void;
  isSystemCompact?: boolean;
  isBasket?: boolean;
  hideInfo?: boolean;
  isClosedPool?: boolean;
};

const Grid = ({
  className,
  matches,
  selection,
  resultSelection,
  onCheckBox,
  isSystemCompact = false,
  isBasket = false,
}: Props) => {
  return (
    <div className={className}>
      {matches.map((match, matchIndex) => (
        <GridLine
          key={match.matchId}
          matchIndex={matchIndex}
          isBasket={isBasket}
          competitor1={match.competitor1Name}
          competitor2={match.competitor2Name}
          checks={getChecks(matchIndex, selection, resultSelection, isSystemCompact)}
          matchId={match.matchId}
          onCheckBox={onCheckBox}
        />
      ))}
    </div>
  );
};

export default Grid;
